import Vue from 'vue';
import firebase from 'firebase/app';
import 'firebase/firestore';

import { rateLimitGeocoder } from '@qualle-admin/qutil/dist/geocoder';
import { getLocalTime, isValidDate } from '@qualle-admin/qutil/dist/date';
import { getLineByPrefix } from '@qualle-admin/qutil/dist/ssl';
import moment from 'moment';
import { filterDocuments } from '@/service/documentFilters';

const state = {
  containers: [],
  network_containers: [],
  selected_containers: [],
  sizes: [],
  error: null,
  added_network_containers: [],
};

const mutations = {
  set_containers(state, payload) {
    state.containers = payload;
  },
  set_network_containers(state, payload) {
    state.network_containers = payload;
  },
  set_selected_containers(state, payload) {
    state.selected_containers = payload;
  },
  update_filtered_containers(state, payload) {
    state.containers = payload;
  },
  LOAD_SIZES_DATA(state, data) {
    state.sizes = data;
  },
  update_error(state, payload) {
    state.error = payload;
  },
  set_added_network_containers(state, payload) {
    state.added_network_containers = payload;
  },
};

const actions = {
  get_organization_containers: async ({ commit, rootGetters }, payload) => {
    let orgId;

    if (payload) {
      orgId = payload;
    } else if (
      rootGetters['auth/get_user'] &&
      typeof rootGetters['auth/get_user'].orgId !== 'undefined'
    ) {
      orgId = rootGetters['auth/get_user'].orgId;
    }

    if (typeof orgId !== 'undefined') {
      Vue.prototype.$snapshots.$organization_containers = await firebase
        .firestore()
        .collection('containers')
        .where('orgId', '==', orgId)
        .onSnapshot(({ docs }) => {
          const fDocs = filterDocuments(docs);
          const containers = fDocs.map((doc) => ({
            ...doc.data(),
            id: doc.id,
          }));
          commit('set_containers', containers);
        });
    }
  },
  // load_containers: async ({ commit, rootGetters }) => {
  //   try {
  //     const containersRef = firebase
  //       .firestore()
  //       .collection('containers')
  //       .where('orgId', '==', rootGetters['auth/get_user'].orgId);
  //     const { docs: docsData } = await containersRef.get();
  //     const docs = filterDocuments(docsData);

  //     const containers = docs.map((doc) => ({ ...doc.data(), id: doc.id }));

  //     commit('set_containers', containers);
  //   } catch (error) {
  //     commit('update_error', error);
  //   }
  // },
  get_network_containers: async ({ commit, rootGetters }) => {
    try {
      let query = firebase.firestore().collection('containers');

      query = query.where('orgId', '!=', rootGetters['auth/get_user'].orgId);
      query = query.where('status', '==', 'available');

      Vue.prototype.$snapshots.$containers_network_snapshot = query.onSnapshot(
        ({ docs: docsData }) => {
          const docs = filterDocuments(docsData);
          const containers = docs.map((doc) => ({ ...doc.data(), id: doc.id }));

          commit('set_network_containers', containers);
        }
      );
    } catch (error) {
      commit('update_error', error);
    }
  },

  // Getting all net work containers to diplaying it for guest
  get_All_network_containers: async ({ commit, rootGetters }) => {
    try {
      const containersRef = firebase
        .firestore()
        .collection('containers')
        .where('status', '==', 'available');
      const { docs } = await containersRef.get();
      const containers = docs.map((doc) => ({ ...doc.data(), id: doc.id }));
      return containers;
    } catch (error) {
      commit('update_error', error);
      throw error;
    }
  },

  get_container_by_id: async ({ commit, rootGetters }, payload) => {
    try {
      const containerRef = await firebase
        .firestore()
        .collection('containers')
        .doc(payload)
        .get();
      return containerRef.data();
    } catch (error) {
      commit('update_error', error);
      throw error;
    }
  },
  get_containers_report: async ({ commit, rootGetters }, payload) => {
    let orgId;

    if (payload) {
      orgId = payload;
    } else if (
      rootGetters['auth/get_user'] &&
      typeof rootGetters['auth/get_user'].orgId !== 'undefined'
    ) {
      orgId = rootGetters['auth/get_user'].orgId;
    }

    try {
      const { docs: reports } = await firebase
        .firestore()
        .collection('daily_report')
        .where('orgId', '==', orgId)
        .get();
      const preparedReports = reports.map((report) => ({ ...report.data() }));

      const timeSeriesReport = preparedReports.map(
        ({
          created,
          containersInQueue = 0,
          containersAtRisk = 0,
          containersPastDue = 0,
          totalContainersPastDueAmount = 0,
          totalContainersAtRiskAmount = 0,
        }) => ({
          created,
          containersInQueue,
          containersAtRisk,
          containersPastDue,
          totalContainersPastDueAmount,
          totalContainersAtRiskAmount,
        })
      );

      const totalsReport = {
        containersInQueue: timeSeriesReport.reduce(
          (acc, { containersInQueue }) => acc + containersInQueue,
          0
        ),
        containersAtRisk: timeSeriesReport.reduce(
          (acc, { containersAtRisk }) => acc + containersAtRisk,
          0
        ),
        containersPastDue: timeSeriesReport.reduce(
          (acc, { containersPastDue }) => acc + containersPastDue,
          0
        ),
        totalContainersPastDueAmount: timeSeriesReport.reduce(
          (acc, { totalContainersPastDueAmount }) =>
            acc + totalContainersPastDueAmount,
          0
        ),
        totalContainersAtRiskAmount: timeSeriesReport.reduce(
          (acc, { totalContainersAtRiskAmount }) =>
            acc + totalContainersAtRiskAmount,
          0
        ),
      };

      return { timeSeriesReport, totalsReport };
    } catch (error) {
      commit('update_error', error);
    }
  },
  add_containers_to_network: async (
    { commit, dispatch, rootGetters },
    payload
  ) => {
    const containerBatch = firebase.firestore().batch();
    const defaultexpiryDate = getLocalTime(moment())
      .add(5, 'days')
      .endOf('day')
      .format();

    const containersToAddToNetwork = [];
    const existingContainerErrorList = [];

    try {
      const containersToCreate = payload.map(async (containerItem) => {
        const {
          amount = 0,
          chassisType,
          container,
          expiryDate,
          line,
          location,
          size,
        } = containerItem;

        const date = expiryDate
          ? moment(expiryDate).format()
          : defaultexpiryDate;
        const containerRef = await firebase
          .firestore()
          .collection('containers')
          .doc(`${container}_${rootGetters['auth/get_user'].orgId}`);
        const containerDoc = await containerRef.get();

        const turnRef = firebase
          .firestore()
          .collection('turns')
          .doc(`${container}_${rootGetters['auth/get_user'].orgId}`);
        const turnDoc = await turnRef.get();

        const mergeFields = {
          amount,
          chassisType: chassisType || 'private',
          status: 'available',
          expiryDate: date,
          line,
          location,
          size,
        };

        if (turnDoc.exists) {
          existingContainerErrorList.push(container);
        } else {
          if (containerDoc.exists) {
            containerBatch.update(containerRef, { ...mergeFields });
          } else {
            containersToAddToNetwork.push({ ...containerItem, ...mergeFields });
          }
        }

        return containerItem;
      });

      const containerRequests = await Promise.all(containersToCreate);

      if (containersToAddToNetwork.length) {
        dispatch('create_container', containersToAddToNetwork);
      }

      if (existingContainerErrorList.length) {
        commit(
          'update_error',
          `Some containers were not added, there are existing turns in the system with the following container numbers: \n${existingContainerErrorList.join(
            ', '
          )}`
        );
      }

      await containerBatch.commit();

      dispatch('get_organization_containers');

      dispatch(
        'auth/new_notification',
        {
          type: 'notification',
          message: `Added ${containerRequests.length} containers to marketplace!`,
        },
        { root: true }
      );
    } catch (error) {
      commit('update_error', error);
    }
  },
  create_container: async ({ commit, dispatch, rootGetters }, payload) => {
    const containerBatch = firebase.firestore().batch();
    const existingContainerErrorList = [];

    try {
      const containersToCreate = payload.map(
        async ({
          created = getLocalTime().format(),
          chassis = '',
          container = '',
          expiryDate = '',
          ref = '',
          line = null,
          lfd,
          reported = '',
          size = '',
          location,
          chassisType = 'private',
          status = 'ready',
        }) => {
          const containerRef = await firebase
            .firestore()
            .collection('containers')
            .doc(`${container}_${rootGetters['auth/get_user'].orgId}`);

          const turnRef = firebase
            .firestore()
            .collection('turns')
            .doc(`${container}_${rootGetters['auth/get_user'].orgId}`);
          const turnDoc = await turnRef.get();

          const orgDoc = await firebase
            .firestore()
            .collection('organizations')
            .doc(`${rootGetters['auth/get_user'].orgId}`)
            .get();

          const { address, label = address, lat, lng } = location;

          if (!lat && !lng) {
            location = { ...(await rateLimitGeocoder(address)), label };
          }

          const newContainerData = {
            created,
            chassis,
            chassisType,
            company: orgDoc.data().company,
            container,
            expiryDate,
            ref,
            line: getLineByPrefix(line) || line,
            lfd: getLocalTime(lfd).endOf('day').format(),
            mc: rootGetters['auth/get_user'].mc,
            reported,
            size,
            location,
            status,
            orgId: rootGetters['auth/get_user'].orgId,
            scac: rootGetters['auth/get_user'].scac,
            owner: rootGetters['auth/get_user'].user_id,
          };

          const isNewLocation = !rootGetters[
            'locations/get_empty_locations'
          ].find(({ label }) => label === location.label);

          if (isNewLocation) {
            dispatch('locations/add_empty_location', location, { root: true });
          }

          if (turnDoc.exists) {
            existingContainerErrorList.push(container);
          } else {
            containerBatch.set(containerRef, newContainerData);
          }
        }
      );

      const containerRequests = await Promise.all(containersToCreate);

      await containerBatch.commit();

      dispatch('get_organization_containers');

      if (existingContainerErrorList.length) {
        commit(
          'update_error',
          `Some containers were not uploaded, there are existing turns in the system with the following container numbers: \n${existingContainerErrorList.join(
            ', '
          )}`
        );
      }

      dispatch(
        'auth/new_notification',
        {
          type: 'notification',
          message: `Created ${containerRequests.length} containers`,
        },
        { root: true }
      );
    } catch (error) {
      commit('update_error', error);
    }
  },
  delete_container: async ({ commit, dispatch, rootGetters }, payload) => {
    const existingContainerErrorList = [];

    try {
      const containerBatch = firebase.firestore().batch();
      const containersToDelete = payload.map(async ({ container }) => {
        const containerRef = firebase
          .firestore()
          .collection('containers')
          .doc(`${container}_${rootGetters['auth/get_user'].orgId}`);
        const turnRef = firebase
          .firestore()
          .collection('turns')
          .doc(`${container}_${rootGetters['auth/get_user'].orgId}`);
        const turnDoc = await turnRef.get();

        if (turnDoc.exists) {
          existingContainerErrorList.push(container);
        } else {
          containerBatch.delete(containerRef, { exists: true });
        }

        return container;
      });

      const containerRequests = await Promise.all(containersToDelete);

      await containerBatch.commit();

      dispatch('get_organization_containers');

      if (existingContainerErrorList.length) {
        commit(
          'update_error',
          `Some containers were not deleted, there are existing turns in the system with the following container numbers: \n${existingContainerErrorList.join(
            ', '
          )}`
        );
      }

      dispatch(
        'auth/new_notification',
        {
          type: 'notification',
          message: `Deleted ${containerRequests.length} containers`,
        },
        { root: true }
      );
    } catch (error) {
      commit('update_error', error);
    }
  },
  transfer_containers: async ({ commit, dispatch, rootGetters }, payload) => {
    try {
      const containerBatch = firebase.firestore().batch();
      const containersToTransfer = payload.map(({ container, location }) => {
        const containerRef = firebase
          .firestore()
          .collection('containers')
          .doc(`${container}_${rootGetters['auth/get_user'].orgId}`);

        containerBatch.update(containerRef, { location });

        return container;
      });

      await containerBatch.commit();

      dispatch('get_organization_containers');

      dispatch(
        'auth/new_notification',
        {
          type: 'notification',
          message: `Transferred ${containersToTransfer.length} containers`,
        },
        { root: true }
      );
    } catch (error) {
      commit('update_error', error);
    }
  },
  terminate_containers: async ({ commit, dispatch, rootGetters }, payload) => {
    const containersBatch = firebase.firestore().batch();
    const existingContainerErrorList = [];

    try {
      const [{ containers: containersToTerminate }] = payload;

      const containersToTerminateRequests = containersToTerminate.map(
        async ({ container }) => {
          const containerRef = firebase
            .firestore()
            .collection('containers')
            .doc(`${container}_${rootGetters['auth/get_user'].orgId}`);
          const containerDoc = await containerRef.get();
          const turnRef = firebase
            .firestore()
            .collection('turns')
            .doc(`${container}_${rootGetters['auth/get_user'].orgId}`);
          const turnDoc = await turnRef.get();

          if (turnDoc.exists) {
            existingContainerErrorList.push(container);
          } else {
            if (containerDoc.exists) {
              containersBatch.update(containerRef, { status: 'terminated' });
            }
          }

          return { container };
        }
      );

      const containerRequests = await Promise.all(
        containersToTerminateRequests
      );

      await containersBatch.commit();

      dispatch('get_organization_containers');

      if (existingContainerErrorList.length) {
        commit(
          'update_error',
          `Some containers were not terminated, there are existing turns in the system with the following container numbers: \n${existingContainerErrorList.join(
            ', '
          )}`
        );
      }

      dispatch(
        'auth/new_notification',
        {
          type: 'notification',
          message: `${containerRequests.length} Container${
            containerRequests.length > 1 ? 's' : ''
          } Terminated!`,
        },
        { root: true }
      );
    } catch (error) {
      commit('update_error', error);
    }
  },
  set_filtered_containers: async (
    { commit, rootGetters },
    { value, orgId: tourMc }
  ) => {
    let orgId;

    if (tourMc) {
      orgId = tourMc;
    } else if (
      rootGetters['auth/get_user'] &&
      typeof rootGetters['auth/get_user'].orgId !== 'undefined'
    ) {
      orgId = rootGetters['auth/get_user'].orgId;
    }

    if (typeof orgId !== 'undefined') {
      try {
        const { docs } = await firebase
          .firestore()
          .collection('containers')
          .where('orgId', '==', orgId)
          .get();

        const preparedContainers = docs.map((doc) => ({
          id: doc.id,
          ...doc.data(),
        }));

        const filteredEntities = preparedContainers.filter(
          ({ container, ref, lfd }) => {
            if (isValidDate(value, 'YYYY-MM-DD', true)) {
              return getLocalTime(lfd).isSame(getLocalTime(value), 'day');
            } else {
              return (
                new RegExp(value, 'gi').test(container) ||
                new RegExp(value, 'gi').test(ref)
              );
            }
          }
        );

        commit('update_filtered_containers', filteredEntities);
      } catch (error) {
        commit('update_error', error);
      }
    }
  },
  set_selected_containers: async ({ commit }, payload) => {
    commit('set_selected_containers', payload);
  },
  get_sizes: async ({ commit }) => {
    try {
      const { docs: sizes } = await firebase
        .firestore()
        .collection('container_sizes')
        .get();

      const sizesData = sizes.map((doc) => ({ id: doc.id, ...doc.data() }));

      commit('LOAD_SIZES_DATA', sizesData);
    } catch (error) {
      commit('LOAD_SIZES_DATA', []);
    }
  },
  get_containers_added_to_network: async ({ commit, rootGetters }) => {
    try {
      let query = firebase.firestore().collection('containers');

      query = query.where('orgId', '==', rootGetters['auth/get_user'].orgId);
      query = query.where('status', '==', 'available');
      query.onSnapshot(({ docs: docsData }) => {
        const docs = filterDocuments(docsData);
        const containers = docs.map((doc) => ({ ...doc.data(), id: doc.id }));

        commit('set_added_network_containers', containers);
      });
    } catch (error) {
      commit('update_error', error);
    }
  },
  remove_container_from_network: async (
    { commit, dispatch, rootGetters },
    payload
  ) => {
    const batch = firebase.firestore().batch();

    try {
      const containersToRemove = payload.map(
        async ({ container, orgId, owner }) => {
          const containerRef = await firebase
            .firestore()
            .collection('containers')
            .doc(`${container}_${orgId}`);

          batch.update(containerRef, {
            expiryDate: firebase.firestore.FieldValue.delete(),
            status: 'ready',
          });

          const pendingRef = await firebase
            .firestore()
            .collection('pending_reservations')
            .doc(container);

          pendingRef.get().then((doc) => {
            if (doc.exists) {
              pendingRef.delete();
            }
          });

          const { docs: reservationDocs } = await firebase
            .firestore()
            .collection('reservations')
            .where('container.container', '==', container)
            .get();

          reservationDocs.forEach((doc) =>
            batch.update(doc.ref, { status: 'canceled', canceledBy: owner })
          );
        }
      );

      const containerRequests = await Promise.all(containersToRemove);

      await batch.commit();

      dispatch(
        'auth/new_notification',
        {
          type: 'notification',
          message: `Removed ${containerRequests.length} containers from network!`,
        },
        { root: true }
      );
    } catch (error) {
      commit('update_error', error);
    }
  },

  // Update the container data
  update_container: async ({ commit, dispatch, rootGetters }, payload) => {
    const containerBatch = firebase.firestore().batch();
    const pendingReservationBatch = firebase.firestore().batch();
    try {
      const containersToUpdate = payload.map(async (containerData) => {
        const containerRef = firebase
          .firestore()
          .collection('containers')
          .doc(`${containerData.id}`);
        containerData.expiryDate = moment(containerData.expiryDate).format();
        containerBatch.set(containerRef, containerData, { merge: true });

        const pendingReservationRef = firebase
          .firestore()
          .collection('pending_reservations')
          .doc(`${containerData.container}`);
        const pendingReservationDoc = await pendingReservationRef.get();

        if (pendingReservationDoc.exists) {
          pendingReservationBatch.set(pendingReservationRef, containerData, {
            merge: true,
          });
        }
        return payload.container;
      });
      await containerBatch.commit();
      await pendingReservationBatch.commit();

      dispatch(
        'auth/new_notification',
        {
          type: 'notification',
          message: `Updated ${containersToUpdate.length} container${
            containersToUpdate.length > 1 ? 's' : ''
          }`,
        },
        { root: true }
      );
    } catch (error) {
      commit('update_error', error);
    }
  },
};

const getters = {
  get_containers(state) {
    return state.containers;
  },
  get_network_containers(state) {
    return state.network_containers;
  },
  get_selected_containers(state) {
    return state.selected_containers;
  },
  get_sizes(state) {
    return state.sizes;
  },
  get_error(state) {
    return state.error;
  },
  get_added_network_containers(state) {
    return state.added_network_containers;
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
